import PropTypes from "prop-types";
import React from "react";
import styled from "@emotion/styled";

import BaseLink from "~/components/links/BaseLink";

import FaIcon from "~/components/FaIcon";

import { ScreenReaderText } from "~/styles/screenReaderText";

const PaddedLink = styled(BaseLink)`
    padding: 5px;
`;

const IconOnlyLink = ({
    icon,
    iconLibrary = "",
    screenReaderText = "",
    url,
    ariaLabel = "",
    ...props
}) => (
    <PaddedLink to={url} {...props} {...{ ariaLabel }}>
        <FaIcon name={icon} {...{ iconLibrary }} />
        {screenReaderText ? (
            <ScreenReaderText>{screenReaderText}</ScreenReaderText>
        ) : null}
    </PaddedLink>
);

IconOnlyLink.propTypes = {
    icon: PropTypes.string.isRequired,
    iconLibrary: PropTypes.string,
    screenReaderText: PropTypes.string,
    ariaLabel: PropTypes.string,
    url: PropTypes.string.isRequired,
};

export default IconOnlyLink;
